import { Injectable } from "@angular/core";
import { ServiceProviderMarkerIcon } from "../interfaces/ServiceProviderMarkerIcon";

@Injectable({
    providedIn: 'root',
})
export class SharedToolsService {
    constructor() {}

    /**
     * Retrieves the icon and name of the network provider based on the MNC and type
     * @param mnc Mobile Network Code returned from the API
     * @param type Type of availability/state. (Accepted, Previous, Current, null, Pending, Online, Offline)
     * @returns @type ServiceProviderMarkerIcon
     */
    GetBasicTowerMarkerInfo(
        mnc: number,
        type: 'a' | 'p' | 'c' | null | 'pending' | 'online' | 'offline'
    ): ServiceProviderMarkerIcon {
        let markerInfo: ServiceProviderMarkerIcon = {
            icon: '',
            name: '',
        };
    
        let switchVal = `${mnc}${type}`;
        let splitSwitch = [`${mnc}`, `${type}`];
    
        switch (true) {
          // VODACOM
          case switchVal == '1a': // Vodacom Accepted
            markerInfo.icon = 'VodacomAcceptedMarker.png';
            markerInfo.name = 'Vodacom';
            break;
          case switchVal == '1p': // Vodacom Previous
            markerInfo.icon = 'VodacomPreviousMarker.png';
            markerInfo.name = 'Vodacom';
            break;
          case switchVal == '1c': // Vodacom Current
            markerInfo.icon = 'VodacomCurrentMarker.png';
            markerInfo.name = 'Vodacom';
            break;
          case switchVal == '1null': // Vodacom
            markerInfo.icon = 'VodacomMarker.png';
            markerInfo.name = 'Vodacom';
            break;
          case switchVal == '1pending': // Vodacom Pending
            markerInfo.icon = 'VodacomPendingMarker.png';
            markerInfo.name = 'Vodacom';
            break;
          case switchVal == '1online': // Vodacom Online
            markerInfo.icon = 'VodacomOnlineMarker.png';
            markerInfo.name = 'Vodacom';
            break;
          case switchVal == '1offline': // Vodacom Offline
            markerInfo.icon = 'VodacomOfflineMarker.png';
            markerInfo.name = 'Vodacom';
            break;
          // TELKOM
          case switchVal == '2a': // Telkom Accepted
          case switchVal == '5a': // Telkom Accepted
            markerInfo.icon = 'TelkomAcceptedMarker.png';
            markerInfo.name = 'Telkom';
            break;
          case switchVal == '2p': // Telkom Previous
          case switchVal == '5p': // Telkom Previous
            markerInfo.icon = 'TelkomPreviousMarker.png';
            markerInfo.name = 'Telkom';
            break;
          case switchVal == '2c': // Telkom Current
          case switchVal == '5c': // Telkom Current
            markerInfo.icon = 'TelkomCurrentMarker.png';
            markerInfo.name = 'Telkom';
            break;
          case switchVal == '2null': // Telkom
          case switchVal == '5null': // Telkom
            markerInfo.icon = 'TelkomMarker.png';
            markerInfo.name = 'Telkom';
            break;
          case switchVal == '5pending': // Telkom Pending
          case switchVal == '2pending': // Telkom Pending
            markerInfo.icon = 'TelkomPendingMarker.png';
            markerInfo.name = 'Telkom';
            break;
          case switchVal == '2online': // Telkom Online (Accepted)
          case switchVal == '5online': // Telkom Online (Accepted)
            markerInfo.icon = 'TelkomAcceptedMarker.png';
            markerInfo.name = 'Telkom';
            break;
          case switchVal == '2offline': // Telkom Offline (Current, was like this when I found it)
          case switchVal == '5offline': // Telkom Offline (Current, was like this when I found it)
            markerInfo.icon = 'TelkomCurrentMarker.png';
            markerInfo.name = 'Telkom';
            break;
          // CELL C
          case switchVal == '7a': // Cell C Accepted
            markerInfo.icon = 'CellCAcceptedMarker.png';
            markerInfo.name = 'Cell C';
            break;
          case switchVal == '7p': // Cell C Previous
            markerInfo.icon = 'CellCPreviousMarker.png';
            markerInfo.name = 'Cell C';
            break;
          case switchVal == '7c': // Cell C Current
            markerInfo.icon = 'CellCCurrentMarker.png';
            markerInfo.name = 'Cell C';
            break;
          case switchVal == '7null': // Cell C
            markerInfo.icon = 'CellCMarker.png';
            markerInfo.name = 'Cell C';
            break;
          case switchVal == '7pending': // Cell C Pending
            markerInfo.icon = 'CellCPendingMarker.png';
            markerInfo.name = 'Cell C';
            break;
          case switchVal == '7online': // Cell C Online
            markerInfo.icon = 'CellCOnlineMarker.png';
            markerInfo.name = 'Cell C';
            break;
          case switchVal == '7offline': // Cell C Offline
            markerInfo.icon = 'CellCOfflineMarker.png';
            markerInfo.name = 'Cell C';
            break;
          // MTN
          case switchVal == '10a': // MTN Accepted
          case switchVal == '12a': // MTN Accepted
            markerInfo.icon = 'MTNAcceptedMarker.png';
            markerInfo.name = 'MTN';
            break;
          case switchVal == '10p': // MTN Previous
          case switchVal == '12p': // MTN Previous
            markerInfo.icon = 'MTNPreviousMarker.png';
            markerInfo.name = 'MTN';
            break;
          case switchVal == '10c': // MTN Current
          case switchVal == '12c': // MTN Current
            markerInfo.icon = 'MTNCurrentMarker.png';
            markerInfo.name = 'MTN';
            break;
          case switchVal == '10null': // MTN
          case switchVal == '12null': // MTN
            markerInfo.icon = 'MTNMarker.png';
            markerInfo.name = 'MTN';
            break;
          case switchVal == '10pending': // MTN Pending
          case switchVal == '12pending': // MTN Pending
            markerInfo.icon = 'MTNPendingMarker.png';
            markerInfo.name = 'MTN';
            break;
          case switchVal == '10online': // MTN Online
          case switchVal == '12online': // MTN Online
            markerInfo.icon = 'MTNOnlineMarker.png';
            markerInfo.name = 'MTN';
            break;
          case switchVal == '10offline': // MTN Offline
          case switchVal == '12offline': // MTN Offline
            markerInfo.icon = 'MTNOfflineMarker.png';
            markerInfo.name = 'MTN';
            break;
          // OTHER MNC
          case splitSwitch[0] !== 'null' && splitSwitch[1] == 'a': // Other Accepted
            markerInfo.icon = 'OtherAcceptedMarker.png';
            markerInfo.name = 'Other';
            break;
          case splitSwitch[0] !== 'null' && splitSwitch[1] == 'p': // Other Previous
            markerInfo.icon = 'OtherPreviousMarker.png';
            markerInfo.name = 'Other';
            break;
          case splitSwitch[0] !== 'null' && splitSwitch[1] == 'c': // Other Current
            markerInfo.icon = 'OtherCurrentMarker.png';
            markerInfo.name = 'Other';
            break;
    
          case splitSwitch[0] !== 'null' && splitSwitch[1] == 'null': // Other
            markerInfo.icon = 'OtherMarker.png';
            markerInfo.name = 'Other';
            break;
    
          // GENERIC
          case switchVal == 'nulla': // Generic Accepted
            markerInfo.icon = 'GenericAcceptedMarker.png';
            markerInfo.name = 'Generic';
            break;
          case switchVal == 'nullp': // Generic Previous
            markerInfo.icon = 'GenericPreviousMarker.png';
            markerInfo.name = 'Generic';
            break;
          case switchVal == 'nullc': // Generic Current
            markerInfo.icon = 'GenericCurrentMarker.png';
            markerInfo.name = 'Generic';
            break;
    
          // DEFAULT
          default:
            markerInfo.icon = 'DefaultMarker.png';
            markerInfo.name = 'Default';
            break;
        }
        return markerInfo;
    }
    
    /**
     * Function that determines and returns the network name based on the MNC
     * @param mnc Mobile Network Code returned from the API
     * @returns String with the network name
     */
    GetNetworkNameByMNC(mnc: number): string {
        switch (mnc) {
          case 1: // Vodacom
            return 'Vodacom';
          case 2: // Telkom
          case 5: // Telkom
            return 'Telkom';
          case 7: // Cell C
            return 'Cell C';
          case 10: // MTN
          case 12: // MTN
            return 'MTN';
          default:
            return 'Other';
        }
    }

    FormatStartDate = (oldFormat: string): string => {
      const theDate: Date = new Date(oldFormat);
      theDate.setHours(2, 0, 0, 0);
      return theDate.toISOString();
    };
  
    FormatEndDate = (oldFormat: string): string => {
      const theDate: Date = new Date(oldFormat);
      theDate.setDate(theDate.getDate() + 1);
      theDate.setHours(1, 59, 59, 999);
      return theDate.toISOString();
    };

    FormatDateFromDate(date: Date): string {
      return date.toLocaleDateString('sv-SE');
    }

    GetStartOfMonth(date: Date): Date {
      let newDate = new Date(date.getFullYear(), date.getMonth(), 1);
      newDate.setHours(0, 0, 0);
      return newDate;
    }

    ParseAPIDateWithTimezone = (date: string): Date => {
      let newDate = new Date();
      newDate.setFullYear(parseInt(date.slice(0, 4)));
      newDate.setMonth(parseInt(date.slice(5, 7)) - 1);
      newDate.setDate(parseInt(date.slice(8, 10)));
      newDate.setHours(parseInt(date.slice(11, 13)));
      newDate.setMinutes(parseInt(date.slice(14, 16)));
      newDate.setSeconds(parseInt(date.slice(17, 19)));
      return newDate;
    };

    FormatDateTimeFromDateSwedish(date: Date): string {
      return date.toLocaleDateString('sv-SE') + ' ' + date.toLocaleTimeString('sv-SE');
    }

    BytesConversion(value: number, to: "b" | "mb" | "kb" | "gb" | "tb"): number {
      let convertedValue: number;
  
      switch (to) {
        case "b":
          convertedValue = value;
          break;
        case "kb":
          convertedValue = value / 1_000;
          break;
        case "mb":
          convertedValue = value / 1_000_000;
          break;
        case "gb":
          convertedValue = value / 1_000_000_000;
          break;
        case "tb":
          convertedValue = value / 1_000_000_000_000;
          break;
      }
  
      return +(convertedValue.toFixed(2));
    }

    DestroyInterval(inter: any) {
      if (inter != null) {
        clearInterval(inter);
      }
    }

    /**
     * @description Gets the pagination headers from a get response or a post and observe response
     * @param response The response object
     * @returns The relevant pagination object if it exists
     */
    getPaginationHeaders(response: any): any {
      let paginationString = response['headers'].get('x-pagination');
      if (paginationString == null) {
        return null;
      }
      return JSON.parse(paginationString) as any;
    }

    handleZoom(event: WheelEvent, map: google.maps.Map): void {
      event.preventDefault(); // Prevent default zooming
      map.setOptions({isFractionalZoomEnabled: true});
  
      if (map) {
        const currentZoom = map.getZoom() || 0;
        // Custom zoom logic
        const zoomStep = 0.1
        if (event.deltaY < 0) {
          map.setZoom(currentZoom + zoomStep); // Zoom in
        } else if (event.deltaY > 0) {
          map.setZoom(currentZoom - zoomStep); // Zoom out
        }
      }
    }

  }